import ApiClient from "../ApiClient";
import PagedResult from "../../models/shared/PagedResult";
import FinancingRequestList from "../../models/admin/financing-request/FinancingRequestList";
import FinancingRequestDetails from "../../models/admin/financing-request/FinancingRequestDetails";
import FinancingRequestFilter from "../../models/admin/financing-request/FinancingRequestFilter";
import FinancingRequestFilterValue from "../../models/admin/financing-request/FinancingRequestFilterValue";

export default class FinancingRequestApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "admin/financing-requests/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getFinancingRequests(page?: number, pageItems?: number) {
    const requests = await this.apiClient.get(
      this.urlPrefix + `?&page=${page}&pageSize=${pageItems}`
    );

    return requests as PagedResult<FinancingRequestList>;
  }

  async getFinancingRequestDetails(id: string) {
    const details = await this.apiClient.get(`${this.urlPrefix}${id}/details`);

    return details as FinancingRequestDetails;
  }

  async updateStatus(
    financingRequestId: number,
    statusId: number,
    changeReason: string
  ) {
    await this.apiClient.put(`${this.urlPrefix}${financingRequestId}/status`, {
      statusId: statusId,
      changeReason: changeReason
    });
  }

  async getSearchFilters() {
    const filters = await this.apiClient.get(`${this.urlPrefix}search/filters`);
    return filters as FinancingRequestFilter;
  }

  async search(
    filter: FinancingRequestFilterValue,
    page?: number,
    pageItems?: number
  ) {
    const requests = await this.apiClient.get(
      `${this.urlPrefix}search?page=${page}` +
        `&pageSize=${pageItems}` +
        `&schoolTypeId=${filter.schoolTypeId || ""}` +
        `&schoolId=${filter.schoolId || ""}` +
        `&schoolYearId=${filter.schoolYearId || ""}` +
        `&status=${filter.status || ""}`
    );

    return requests as PagedResult<FinancingRequestList>;
  }

  async getCanStatusReturnRequest(financingRequestId: number) {
    const respons = await this.apiClient.get(this.urlPrefix + `can-return-request?financingRequestId=${financingRequestId}`);
    return respons as boolean;
  }

  async updateSchoolCarrierNote(id: number, newNote: string) {
    const response = await this.apiClient.put(this.urlPrefix + `schoolcarrier/note`, {id: id, note: newNote});
    return response;
  }

  async updateAuthorizedCarrierNote(id: number, newNote: string) {
    const response = await this.apiClient.put(this.urlPrefix + `authorizedcarrier/note`, {id: id, note: newNote});
    return response;
  }

  async updateStudentNote(id: number, newNote: string) {
    const response = await this.apiClient.put(this.urlPrefix + `student/note`, {id: id, note: newNote});
    return response;
  }

  async updateDecisionNote(id: number, newNote: string) {
    const response = await this.apiClient.put(this.urlPrefix + `decision/note`, {id: id, note: newNote});
    return response;
  }
}
